module.exports = __webpack_public_path__ + "img/line.005102ae.jpg";